(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbPanel', lbPanelDirective)
    ;

    function lbPanelDirective() {
        return {
            restrict: 'E',
            scope: {
                panel: "=",
                model: '=',
                content: '='
            },
            //templateUrl: '/api/admin/templates/panel',
            controller: lbPanelDirectiveCtrl
        };
    }

    function lbPanelDirectiveCtrl ($scope, $element, $compile, lodash, PanelRegistry) {
        this.$onInit = function() {
            var type = lodash.get($scope, 'panel.panel_type.name', '');

            PanelRegistry.register($scope.panel.panel_type.identifier, $scope.panel);
            // Types: grid, form, template, tabstrip
            var template = '<lb-' + type + '-panel panel="panel" model="model" content="content"></lb-' + type + '-panel>';
            $element.html(template);
            var cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', function () {
                cloneElement.off();
            });
        }
    }
})();